import { useSelector, shallowEqual } from 'react-redux';

/**
 * Redux selector for product compare state
 */
const productCompareSelector = state => state.productCompare || { isCompareModeEnabled: false, selectedProducts: [] };

/**
 * Hook to read full compare state from Redux
 * Returns both the mode enabled state and selected products
 */
export const useCompareState = () => {
    return useSelector(productCompareSelector, shallowEqual);
};

/**
 * Hook to read only selectedProducts from Redux
 * For components that only need the products list
 */
export const useCompareProducts = () => {
    const { selectedProducts = [] } = useSelector(productCompareSelector, shallowEqual);

    return selectedProducts;
};

export default useCompareProducts;
